import React from "react";

import { Truncated } from "~/components/truncated";

import type { DashboardReadBaseSchema } from "../../../common/openapi";
import { DashboardScopeIcon } from "../../../components/_dashboard-scope-icon";
import { DashboardStar } from "../../../components/dashboard-star";
import { useNavigateToLink } from "../../../components/react/link";
import { DASHBOARD_PATH } from "../../../routes/Routes";
import { MainMenuItemLayout } from "../MainMenuItemLayout";

const DashboardLabel: React.FC<{
	dashboard: DashboardReadBaseSchema;
	name: string;
}> = ({ name, dashboard }) => (
	<div className="flex flex-row items-center justify-start gap-2">
		<Truncated>{name}</Truncated>
		{/* the star should have relative position so it is clickable */}
		<DashboardStar className="relative" id={dashboard.id!} />
	</div>
);

export interface DashboardMenuItemViewProps {
	dashboard: DashboardReadBaseSchema;
}

export const DashboardMenuItemView: React.FC<DashboardMenuItemViewProps> = ({ dashboard }) => {
	const link = useNavigateToLink(DASHBOARD_PATH, {
		params: {
			idOrIdentifier: dashboard.id,
		},
		search: ["timeRange", "timestamp", "detachedFilters"],
	});

	return (
		<MainMenuItemLayout
			icon={<DashboardScopeIcon className="-mt-0.5" dashboardScope={dashboard.scope} />}
			label={<DashboardLabel dashboard={dashboard} name={dashboard.name} />}
			level={1}
			to={link}
		/>
	);
};
